import { useState, useEffect } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME = 'improveNotificationExperience_Feb2026';
const MW_NOTIFICATION_DESIGN_ITERATION_TEST_NAME = 'mwNotificationDesignIteration_May2026';

let userNotificationsTestHasBeenTracked = false;
let mwNotificationDesignIterationTestHasBeenTracked = false;

export const useUpdatedNotificationContentVariant = (): boolean | null => {
    const [isVariant, setIsVariant] = useState<boolean | null>(null);

    useEffect(() => {
        const test = getAbTestV2(IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME);

        if (!test) {
            setIsVariant(false);
            return;
        }

        setIsVariant(test.variant === 'variant');

        if (!userNotificationsTestHasBeenTracked) {
            trackAbTestV2Variant(IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME);
            userNotificationsTestHasBeenTracked = true;
        }
    }, []);

    return isVariant;
};

export const isUpdatedNotificationContentVariant = (): boolean => {
    return getAbTestV2(IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME)?.variant === 'variant';
};

/**
 * MW-only A/B test. Trigger fires on every MW header load (call from a MW-only
 * component). Returns true when the user is in the `variant` bucket.
 */
export const useMwNotificationDesignIterationVariant = (): boolean | null => {
    const [isVariant, setIsVariant] = useState<boolean | null>(null);

    useEffect(() => {
        const test = getAbTestV2(MW_NOTIFICATION_DESIGN_ITERATION_TEST_NAME);

        if (!test) {
            setIsVariant(false);
            return;
        }

        setIsVariant(test.variant === 'variant');

        if (!mwNotificationDesignIterationTestHasBeenTracked) {
            trackAbTestV2Variant(MW_NOTIFICATION_DESIGN_ITERATION_TEST_NAME);
            mwNotificationDesignIterationTestHasBeenTracked = true;
        }
    }, []);

    return isVariant;
};
